import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';

import s from './Audio.scss';

import messages from '../lessonDetailsMessages';

@withStyles(s)
@injectIntl
@connect(state => ({
  auth: state.auth,
  lesson: state.lessonDetails.lesson,
}))
export default class Audio extends React.Component {
  static propTypes = {
    complete: PropTypes.func.isRequired,
    lesson: PropTypes.object.isRequired,  // eslint-disable-line
    intl: intlShape.isRequired,
    podcastAudioContentClass: PropTypes.string,
    play: PropTypes.bool,
    goToNextLesson: PropTypes.func,
    setPlayPodcastAudio: PropTypes.func,
    setAudioEnded: PropTypes.func,
  };

  static defaultProps = {
    podcastAudioContentClass: '',
    play: false,
    goToNextLesson: _.noop,
    setPlayPodcastAudio: _.noop,
    setAudioEnded: _.noop,
  };

  static contextTypes = {
    cloudfrontUrl: PropTypes.string,
  };

  componentDidMount() {
    if (this.props.play) {
      const player = document.getElementById('lessonAudio');
      _.invoke(player, 'play');
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.get(prevProps, 'play') && _.get(this, 'props.play')) {
      const player = document.getElementById('lessonAudio');
      _.invoke(player, 'play');
    }
    if (_.get(prevProps, 'play') && !_.get(this, 'props.play')) {
      const player = document.getElementById('lessonAudio');
      _.invoke(player, 'pause');
    }
  }

  onAudioTimeUpdate = ({ target: { currentTime, duration } }) => {
    const { lesson, complete } = this.props;
    const position = currentTime / duration;

    if (position > 0.9 && !lesson.isCompleted) {
      complete();
    }

    if (position < 0.99) {
      this.props.setAudioEnded(false);
    }

    if (position === 1) {
      this.props.setAudioEnded(true);
    }
  };

  onPlay = () => {
    this.props.setPlayPodcastAudio(true);
  };

  onPause = () => {
    this.props.setPlayPodcastAudio(false);
  };

  render() {
    const { lesson, podcastAudioContentClass } = this.props;
    return (
      <div
        className={classNames({
          [s.lessonAudioContent]: !podcastAudioContentClass,
          [podcastAudioContentClass]: podcastAudioContentClass,
        })}
        key={_.get(lesson, '_id')}
      >
        <audio // eslint-disable-line jsx-a11y/media-has-caption
          controlsList="nodownload"
          id="lessonAudio"
          onTimeUpdate={this.onAudioTimeUpdate}
          onEnded={this.props.goToNextLesson}
          onPlay={this.onPlay}
          onPause={this.onPause}
          controls
        >
          {_.map(lesson.audios, ({ _id, file: { path, mimetype } }) => (
            <source
              key={_id}
              src={`${this.context.cloudfrontUrl}/${path}`}
              type={mimetype}
            />
          ))}
          <FormattedMessage {...messages.browserDoesntSupportAudioMsg} />
        </audio>
      </div>
    );
  }
}
